module.exports = __webpack_public_path__ + "static/media/ic_clipboard.b3801561.svg";